const skierLayers = [
    {
      id: 'MIJ',
      src: '/animation_assets/49_ski_MIJ.png',
      width: '279.9px',
      height: '2.6px',
      left: '22.7%',
      top: '54.8%',
      zIndex: 12,
      role: 'secondary',
      group: 1, // Default group,
      alt: 'Thin horizontal blue line graphic.'
    },
    {
      id: 'QKT',
      src: '/animation_assets/49_ski_QKT.png',
      width: '192.2px',
      height: '3.5px',
      left: '39.8%',
      top: '69.2%',
      zIndex: 11,
      role: 'secondary',
      group: 1, // Default group,
      alt: 'Solid horizontal teal rectangle shape'
    },
    {
      id: 'DII',
      src: '/animation_assets/49_ski_DII.png',
      width: '110.6px',
      height: '53.3px',
      left: '55.5%',
      top: '44.3%',
      zIndex: 10,
      role: 'secondary',
      group: 0, // Default group,
      alt: 'Light blue mountain silhouette.'
    },
    {
      id: 'EHP',
      src: '/animation_assets/49_ski_EHP.png',
      width: '97.1px',
      height: '109.9px',
      left: '41.6%',
      top: '33.6%',
      zIndex: 9,
      role: 'primary',
      group: 0, // Default group,
      alt: 'Illustration of a skier skiing.'
    },
    {
      id: 'AII',
      src: '/animation_assets/49_ski_AII.png',
      alt: 'CARDINALS',
      width: '280.0px',
      height: '53.8px',
      left: '22.7%',
      top: '56.8%',
      zIndex: 8,
      role: 'text',
      group: 0, // Default group
    },
    {
      id: 'BKK',
      src: '/animation_assets/49_ski_BKK.png',
      alt: 'SKI CLUB',
      width: '80.2px',
      height: '19.7px',
      left: '22.8%',
      top: '67.4%',
      zIndex: 7,
      role: 'text',
      group: 0, // Default group
    },
    {
      id: 'KUC',
      src: '/animation_assets/49_ski_KUC.png',
      width: '113.5px',
      height: '55.0px',
      left: '22.7%',
      top: '44.3%',
      zIndex: 6,
      role: 'secondary',
      group: 0, // Default group,
      alt: 'Simplified white mountain silhouette graphic'
    },
    {
      id: 'DXW',
      src: '/animation_assets/49_ski_DXW.png',
      width: '279.9px',
      height: '140.4px',
      left: '22.7%',
      top: '27.4%',
      zIndex: 5,
      role: 'background',
      group: 0, // Default group,
      alt: 'Teal semicircle shape graphic.'
    },
    {
      id: 'RMZ',
      src: '/animation_assets/49_ski_RMZ.png',
      width: '512.0px',
      height: '512.0px',
      left: '0.0%',
      top: '0.0%',
      zIndex: 4,
      role: 'background',
      group: 0, // Default group,
      alt: 'Solid light blue square shape.'
    }
  ];
  
  export default skierLayers;
  